class ComponentHero extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.data = this.querySelector('[id*="Section-Component-Hero-Data-"]');
    this.init();
  }

  init() {
    if (!this.data) return;

    try {
      this.phrases = JSON.parse(this.data.textContent);

      carousel(this.phrases, this.querySelector('[data-rotating-text]'));

      this.classList.add('is-initialized');
    } catch (error) {
      console.error(error.message);
    }
  }
}

customElements.define('component-hero', ComponentHero);
